import { ITEM_FRAGMENT } from "@shared/graphql.fragments";
import { getClient, toCacheId } from "lib/apolloClient";
import type { ItemType } from "@shared/graphql.types";

export function getItem(itemId: string): ItemType {
  return getClient().readFragment<ItemType>({
    id: toCacheId("ItemType", itemId),
    fragment: ITEM_FRAGMENT,
    fragmentName: "ItemFragment"
  }) as ItemType;
}
